class MainBlogLoadMore {
  constructor(container) {
    this.container = container;
    this.articleGrid = this.container.querySelector('[data-blog-articles]');
    this.controls = this.container.querySelector('[data-blog-pagination-controls]');
    this.isLoading = false;

    this.onClick = this.onClick.bind(this);
    this.bindButton();
  }

  bindButton() {
    this.button = this.container.querySelector('[data-blog-load-more-button]');
    if (!this.button || !this.articleGrid) return;

    this.button.addEventListener('click', this.onClick);
  }

  async onClick(event) {
    event.preventDefault();

    if (this.isLoading || !this.button.href) return;

    const nextUrl = this.button.href;
    this.setLoading(true);

    try {
      const response = await fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error(`Unable to load blog page: ${response.status}`);

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextArticles = nextDocument.querySelectorAll('[data-blog-articles] > .blog-articles__article');

      if (!nextArticles.length) throw new Error('No blog articles found on next page.');

      const fragment = document.createDocumentFragment();
      nextArticles.forEach((article) => {
        fragment.appendChild(document.importNode(article, true));
      });

      this.articleGrid.appendChild(fragment);
      this.refreshScrollAnimations();
      this.refreshControls(nextDocument);
    } catch (error) {
      window.location.href = nextUrl;
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    if (!this.button) return;

    this.isLoading = isLoading;

    if (isLoading) {
      this.button.dataset.originalText = this.button.textContent.trim();
      this.button.textContent = this.button.dataset.loadingText || 'Loading...';
      this.button.setAttribute('aria-busy', 'true');
      this.button.classList.add('blog-load-more__button--loading');
      return;
    }

    this.button.textContent = this.button.dataset.originalText || 'View more';
    this.button.setAttribute('aria-busy', 'false');
    this.button.classList.remove('blog-load-more__button--loading');
  }

  refreshControls(nextDocument) {
    const nextControls = nextDocument.querySelector('[data-blog-pagination-controls]');

    if (!this.controls) return;

    if (nextControls) {
      this.controls.innerHTML = nextControls.innerHTML;
      this.bindButton();
      return;
    }

    this.controls.remove();
    this.controls = null;
    this.button = null;
  }

  refreshScrollAnimations() {
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(this.articleGrid);
      return;
    }

    this.articleGrid.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.remove('scroll-trigger--offscreen');
      element.classList.add('scroll-trigger--cancel');
    });
  }
}

function initializeMainBlogLoadMore(root = document) {
  root.querySelectorAll('[data-blog-load-more-root]').forEach((container) => {
    if (container.dataset.blogLoadMoreInitialized === 'true') return;

    container.dataset.blogLoadMoreInitialized = 'true';
    new MainBlogLoadMore(container);
  });
}

document.addEventListener('DOMContentLoaded', () => initializeMainBlogLoadMore());
document.addEventListener('shopify:section:load', (event) => initializeMainBlogLoadMore(event.target));
